import { useEffect } from "react";

declare global {
  interface Window {
    Tawk_API?: any;
  }
}

const TawkToChat = () => {
  useEffect(() => {
    if (window.Tawk_API) return;

    const script = document.createElement("script");
    script.src = "https://embed.tawk.to/67b59a2053c65d190c3c0432/1ikem441a";
    script.async = true;
    script.setAttribute("crossorigin", "*");

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null;
};

export default TawkToChat;
